module.exports = __webpack_public_path__ + "static/media/congratulations.520e11eb.svg";